<template>
  <div>
    <span v-if="label || name" class="label">{{ label || name }}</span>
    <div
      ref="selectBox"
      class="admin-select-box"
      :class="{ open, disabled, 'select-error': errorMessage }"
    >
      <div class="d-flex align-items-center full-width">
        <i class="fa fa-search mx-2"></i>
        <TextField
          v-model="search"
          type="search"
          tabindex="0"
          class="full-width mb-0 mt-2 bg-transparent"
          input-class="autocomplete-input"
          :placeholder="placeholder"
          :disabled="disabled"
          no-label
          @focus="toggleOpen"
        />
      </div>
      <Transition>
        <div v-if="open" class="admin-select-options">
          <div
            v-for="option in filteredOptions"
            :key="option.value"
            class="option"
            data-cy="auto-complete-search"
            :class="{ selected: option.value === selectedValue }"
            @click="handleSelect(option)"
          >
            {{ option.label }}
          </div>
        </div>
      </Transition>
    </div>
    <span v-if="errorMessage" class="text-danger error-text">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
import { findByName } from "@/lib/vuelidate_helpers";

import TextField from "./TextField.vue";
import Transition from "./Transition.vue";

export default {
  name: "AutoComplete",
  components: {
    Transition,
    TextField
  },
  props: {
    modelValue: { type: [Number, String], default: "" },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Select..."
    },
    options: {
      type: Array,
      default: () => []
    },
    validationErrors: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    ignoreFilter: {
      type: Boolean,
      default: false
    }
  },
  emits: ["search", "update:modelValue", "blur", "clicked"],
  data() {
    return {
      search: "",
      open: false,
      selectedValue: null
    };
  },
  computed: {
    filteredOptions() {
      if (this.ignoreFilter) return this.options;
      return this.options.filter((option) =>
        (option.label || "")
          .toLowerCase()
          .includes((this.search || "").toLowerCase())
      );
    },
    errorMessage() {
      if (!this.validationErrors || !this.name) return "";
      return findByName(this.validationErrors, this.name);
    }
  },
  watch: {
    search(newValue, oldValue) {
      // Reset selection when search is cleared
      if (newValue !== oldValue) {
        this.$emit("search", newValue);
        if (!newValue) {
          this.selectedValue = null;
        }
      }
    },
    selectedValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.search = newValue ? this.getSelectedLabel(newValue) : "";
        // Emit update:modelValue to update v-model in parent
        this.$emit("update:modelValue", newValue);
        this.$emit("blur");
      }
    },
    modelValue(newValue, oldValue) {
      // Handle changes from parent
      if (newValue !== oldValue) {
        this.selectedValue = newValue;
      }
    }
  },
  created() {
    if (this.modelValue) {
      this.selectedValue = this.modelValue;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOut);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOut);
  },
  methods: {
    findByName,
    getSelectedLabel(val) {
      return (this.options.find((option) => option.value === val) || {}).label;
    },
    handleClickOut(e) {
      if (!$.contains(this.$refs.selectBox, e.target)) {
        this.open = false;
      }
    },
    handleSelect(option) {
      this.selectedValue = option.value;
      this.open = false;
      this.$emit("clicked", option.value);
    },
    toggleOpen() {
      if (!this.disabled) {
        this.open = true;
      }
    }
  }
};
</script>
